import { apiConfig } from '../config';
import { getFetch } from '../fetch';

interface GetStackParams {
    courseId: number | null | undefined,
    stackIds: any[],
    expandProblems?: unknown,
    showProblems?: boolean,
}

interface GetStackRequest {
    stackIds: string,
    expandProblems: unknown,
    showProblems: boolean | undefined,
    courseId?: number,
}

export function getStacks({ courseId, stackIds, expandProblems, showProblems }: GetStackParams) {
    const { apiGetStacks } = apiConfig.getStaticUrls();
    const requestArgs: GetStackRequest = { stackIds: stackIds.join(','), expandProblems, showProblems };

    if (courseId) {
        requestArgs.courseId = courseId;
    }

    return getFetch(apiGetStacks, requestArgs);
}
